import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      userProfile: {
        USER_PROFILE: 'User Profile',
        EDIT_PROFILE: 'Edit Profile',
        FIRST_NAME: 'First Name',
        MIDDLE_NAME: 'Middle Name',
        LAST_NAME: 'Last Name',
        EMAIL: 'Login/ Email',
        JOB_TITLE: 'Job Title',
        PHONE: 'Phone',
        ACCOUNT_TYPE: 'Account Type',
        COMPANY_NAME: 'Company Name',
        COUNTRY: 'Country',
        TAX_CODE: 'Tax Code/ Registration Number',
        INDUSTRY: 'Industry',
        WEBSITE: 'Website',
        CONTACT_EMAIL: 'Contact Email',
        COMPANY_PHONE: 'Contact Phone',
        ADDRESS: 'Address',
        TITLE: 'Title: ',
        MR: 'Mr',
        MS: 'Ms',
        REQUEST_EDIT_INFO: `Some information must be verified by our team for security reasons.
        To edit these information, click `,
        REQUEST_EDIT: ' Request edit.',
        CHANGE_PASSWORD: 'Change Password',
        CLICK: 'Click ',
        HERE: 'here',
        TO_CHANGE: ' to change password.',
        REQUIRED_FIELD: 'This is a required field!',
        POPUP_REQUEST_TITLE: `Select the field you want to edit from the filter. Insert new
        information in the box below.`,
        SEND_REQUEST: 'Send Request',
        SUCCESS_MESSAGE: `Your request was submitted. We will notify you by email after verifying it. Kindly check your inbox regularly for updates.
        <br/> Thank you for using our service!`,
        UPDATED_SUCCESS: 'Your profile has been updated successfully.',
        SELECT_FIELD: 'Select field',
        SAVE: 'Save',
      },
      settingPreferences: {
        TITLE: 'Preferences & Settings',
        SETTINGS: 'Settings',
        LANGUAGE: 'Language',
        LANGUAGE_PLATFORM: 'Language for Platform',
        LANGUAGE_EMAIL: 'Language for Email',
        VIETNAMESE: 'Vietnamese',
        ENGLISH: 'English',
        TIMEZONE: 'Time Zone',
        CURRENCY: 'Default Currency',
        DATE_FORMAT: 'Date Format',
        FONT_SIZE: 'Font Size',
        SMALL: 'Small',
        MEDIUM: 'Medium',
        LARGE: 'Large',
        PREFERENCES: 'Preferences',
        INTERESTED_INDUSTRIES: 'Interested Industries',
        INTERESTED_LOCATION: 'Interested Location',
        VIETNAM_PROVINCES: 'Vietnam Provinces',
        OTHER_COUNTRIES: 'Other Countries',
        SAVE: 'Save',
        SEARCH_INDUSTRY: 'Search/ Find code or industry name',
        LEVEL: 'Level ',
        SEARCH_PROVINCE: 'Enter a province/ city name',
        SEARCH_COUNTRY: 'Enter a country name',
        ITEMS_SELECTED: ' items selected',
        ITEM_SELECTED: ' item selected',
        CHANGE_SAVED: 'Saved Successfully',
      },
      subscriptionPayment: {
        TERM: 'Term',
        TITLE: 'Subscription & Payment',
        YOUR_SUBSCRIPTION: 'Your Subscription',
        SUBSCRIPTION_TERM: 'Subscription Term',
        YOUR_CURRENT_PLAN: 'Your Current Plan',
        EXPIRY_DATE: 'Expiry Date',
        PROMOTION_CONTEXT:
          'Want to explore in-depth features & benefits from our promotion? Click on %{link} to find out.',
        PROMOTION_CONTEXT_LINK: 'View Plan',
        PROMOTION_CONTEXT_TRIAL:
          '%{link} if you have any requirements or need more information.',
        PROMOTION_CONTEXT_LINK_TRIAL: 'Contact us',
        UPGRADE_NOW: 'Upgrade Now',
        TRIAL_NOW: 'Trial Now',
        CANCEL_TRIAL: 'Cancel Trial',
        REMAINING: 'Remaining:',
        EXISTED_SUBSCRIPTION_STANDARD_MESSAGE:
          'You can only upgrade account when your subscription expires.',
        EXISTED_ORDER_SUBSCRIPTION_MESSAGE:
          'You have previously submitted a upgrading request. Click %{link} to view request detail.',
        TRIAL_MESSAGE: `Your trial period will be valid for 14 days, if you wish,
        you can cancel it anytime.
        <br /><br />
        You'll have unrestricted access to explore numerous company profiles.
        Although transaction capabilities are not available, any reports you purchase
        will be securely stored in the Downloaded Files section, allowing you to download them again whenever needed.
        <br /><br />
        If you have an active package, its usage will still be deducted throughout the trial.
        <br /><br />
        Ready to give it a try?`,
        CANCEL_MESSAGE: 'Do you want to cancel trial?',
        TOOLTIP_UPGRADE:
          'You can only upgrade account when your current subscription expires',
        TOOLTIP_UPGRADE_TRIAL: 'Cancel trial to upgrade account',
        DEACTIVE_TRIAL_MESS: `You have successfully cancelled your trial.`,
        MONTHS: 'months',
        YEARS: 'years',
        DAYS: 'days',
        MONTH: 'month',
        YEAR: 'year',
        DAY: 'day',
        Package: 'Package',
        Subscription: 'Subscription',
        ConnectionMap: 'ConnectMap',
      },
      engagementHistory: {
        TITLE: 'Engagement History',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      userProfile: {
        USER_PROFILE: 'Thông Tin Cá Nhân',
        EDIT_PROFILE: 'Sửa Thông Tin',
        FIRST_NAME: 'Tên',
        MIDDLE_NAME: 'Tên Đệm',
        LAST_NAME: 'Họ',
        EMAIL: 'Đăng Nhập/ Email',
        JOB_TITLE: 'Chức Danh',
        PHONE: 'Số Điện Thoại',
        ACCOUNT_TYPE: 'Loại Tài Khoản',
        COMPANY_NAME: 'Tên Công Ty',
        COUNTRY: 'Quốc Gia',
        TAX_CODE: 'Mã Số Thuế/ Số Đăng Ký',
        INDUSTRY: 'Ngành',
        WEBSITE: 'Website',
        CONTACT_EMAIL: 'Email Liên Hệ',
        COMPANY_PHONE: 'Số Điện Thoại Liên Hệ',
        ADDRESS: 'Địa Chỉ',
        TITLE: 'Danh xưng: ',
        MR: 'Ông',
        MS: 'Bà',
        REQUEST_EDIT_INFO: `Chúng tôi cần xác minh một số thông tin nhất định vì lý do bảo mật. Để chỉnh sửa các thông tin này, nhấn`,
        REQUEST_EDIT: ' Yêu cầu chỉnh sửa.',
        CHANGE_PASSWORD: 'Thay đổi mật khẩu',
        CLICK: 'Bấm vào ',
        HERE: 'đây',
        TO_CHANGE: ' để thay đổi mật khẩu.',
        REQUIRED_FIELD: 'Đây là 1 trường bắt buộc!',
        POPUP_REQUEST_TITLE: `Chọn thông tin muốn chỉnh sửa từ bộ lọc. Nhập thông tin mới vào ô dưới đây.`,
        SEND_REQUEST: 'Gửi yêu cầu',
        SUCCESS_MESSAGE: `Yêu cầu của bạn đã được gửi thành công. Chúng tôi sẽ thông báo kết quả sau khi xác minh yêu cầu của bạn qua email. Vui lòng, kiểm tra hộp thư của bạn thường xuyên để nắm được các cập nhật.
        <br/>  Cảm ơn bạn đã sử dụng dịch vụ của FiinGate!`,
        UPDATED_SUCCESS: 'Thông tin của bạn đã được cập nhật thành công.',
        SELECT_FIELD: 'Chọn thông tin',
        SAVE: 'Lưu',
      },
      settingPreferences: {
        TITLE: 'Cài đặt & Tùy chọn',
        SETTINGS: 'Cài đặt',
        LANGUAGE: 'Ngôn ngữ',
        LANGUAGE_PLATFORM: 'Ngôn Ngữ cho Hệ Thống',
        LANGUAGE_EMAIL: 'Ngôn Ngữ cho Email',
        VIETNAMESE: 'Tiếng Việt',
        ENGLISH: 'Tiếng Anh',
        TIMEZONE: 'Múi Giờ',
        CURRENCY: 'Tiền Tệ Mặc Định ',
        DATE_FORMAT: 'Định Dạng Ngày',
        FONT_SIZE: 'Cỡ Chữ',
        SMALL: 'Nhỏ',
        MEDIUM: 'Vừa',
        LARGE: 'Lớn',
        PREFERENCES: 'Mục ưa thích',
        INTERESTED_INDUSTRIES: 'Các ngành quan tâm',
        INTERESTED_LOCATION: 'Địa điểm quan tâm',
        VIETNAM_PROVINCES: 'Tỉnh/Thành phố Việt Nam',
        OTHER_COUNTRIES: 'Các quốc gia khác',
        SAVE: 'Lưu',
        SEARCH_INDUSTRY: 'Tìm kiếm mã hoặc tên ngành',
        LEVEL: 'Cấp ',
        SEARCH_PROVINCE: 'Nhập tên tỉnh thành/tên thành phố',
        SEARCH_COUNTRY: 'Nhập tên quốc gia',
        ITEMS_SELECTED: ' mục được chọn',
        ITEM_SELECTED: ' mục được chọn',
        CHANGE_SAVED: 'Thay đổi đã được lưu',
      },
      subscriptionPayment: {
        TERM: 'Kỳ hạn',
        TITLE: 'Tài khoản & thanh toán',
        YOUR_SUBSCRIPTION: 'Tài khoản của bạn',
        SUBSCRIPTION_TERM: 'Kỳ Hạn',
        YOUR_CURRENT_PLAN: 'Tài khoản hiện tại',
        EXPIRY_DATE: 'Ngày hết hạn',
        PROMOTION_CONTEXT:
          'Để khám phá các tính năng khác và hưởng lợi từ chương trình khuyến mãi của chúng tôi, nhấn vào nút %{link}',
        PROMOTION_CONTEXT_LINK: 'Xem chi tiết',
        PROMOTION_CONTEXT_TRIAL:
          '%{link} nếu bạn có bất kỳ yêu cầu hoặc cần thêm thông tin',
        PROMOTION_CONTEXT_LINK_TRIAL: 'Liên hệ chúng tôi',
        UPGRADE_NOW: 'Nâng cấp ngay',
        TRIAL_NOW: 'Dùng thử ngay bây giờ',
        CANCEL_TRIAL: 'Hủy dùng thử',
        REMAINING: 'Còn:',
        EXISTED_SUBSCRIPTION_STANDARD_MESSAGE:
          'Bạn chỉ có thể nâng cấp tài khoản khi thuê bao hiện tại của bạn hết hạn.',
        EXISTED_ORDER_SUBSCRIPTION_MESSAGE:
          'Bạn đã gửi một yêu cầu nâng cấp tài khoản trước đó. Nhấn vào %{link} để xem chi tiết yêu cầu.',
        TRIAL_MESSAGE: `Tài khoản dùng thử sẽ có hiệu lực trong 14 ngày,
        bạn có thể chọn ngưng sử dụng tài khoản này trước thời hạn.
        <br /><br />
        Bạn sẽ có quyền truy cập không giới hạn thông tin của một số doanh nghiệp.
        Mặc dù bạn không thể thực hiện các giao dịch tại bản dùng thử, các báo cáo
        bạn đã mua sẽ được lưu trữ an toàn và có thể tải lại tại mục Tài liệu tải xuống.
        <br /><br />
        Nếu bạn đã mua gói, thời hạn sử dụng của các gói đó vẫn bị khấu trừ trong suốt thời gian dùng thử.
        <br /><br />
        Khám phá phiên bản dùng thử ngay hôm nay!`,
        CANCEL_MESSAGE: 'Bạn có muốn hủy dùng thử không?',
        TOOLTIP_UPGRADE:
          'Bạn chỉ có thể nâng cấp tài khoản khi thuê bao hiện tại của bạn hết hạn',
        TOOLTIP_UPGRADE_TRIAL: 'Hủy dùng thử để nâng cấp tài khoản',
        DEACTIVE_TRIAL_MESS: `Bạn đã hủy thành công gói dùng thử.`,
        MONTHS: 'tháng',
        YEARS: 'năm',
        DAYS: 'ngày',
        MONTH: 'tháng',
        YEAR: 'năm',
        DAY: 'ngày',
        Package: 'Gói',
        Subscription: 'Nâng cấp tài khoản',
        ConnectionMap: 'Bản đồ kết nối',
      },
      engagementHistory: {
        TITLE: 'Lịch sử tương tác',
      },
    },
  }),
)
